import { createModuleStore } from '../utils'
import { watch, computed } from 'vue'

export function useZebraReaderConfigsStore() {
  const storeFn = createModuleStore(
    'zebra-reader-configs',
    {
      type: 'Zebra Reader Config',
      pageHeading: 'Zebra Reader Configs',
      noHistory: true,
      sortingOn: 'toolbar',
      statusesFilterName: 'statuses',
      uploadOptionsCsv: '',
      uri: '/readers/configs/zebra',
      serviceUri: '/readers/configs/zebra',
      listingModuleName: 'Config',
      listingActivityName: 'View Zebra Reader Config',
      formModuleName: 'Config',
      toolsConfig: null,
      showToolsActivityModal: false,
      allFields: [
        {
          key: 'name',
          title: 'NAME',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'session',
          title: 'SESSION',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'gpiPort',
          title: 'GPI PORT',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'useTls',
          title: 'USE TLS',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'keepAlivesPeriodMillis',
          title: 'KEEP ALIVE PERIOD MILLIS',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'keepAlivesEnabled',
          title: 'KEEP ALIVES ENABLED',
          type: 'booleanToYesNo',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'receiveSensitivityIndex',
          title: 'RECEIVE SENSITIVITY',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'rfModeTableIndex',
          title: 'RF MODE TABLE',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'transmitFrequencyIndex',
          title: 'TRANSMIT FREQUENCY',
          visible: false,
          sortable: true,
          disabled: false,
        },
        // {
        //   key: 'tari',
        //   title: 'TARI',
        //   visible: false,
        //   sortable: true,
        //   disabled: false,
        // },
        {
          key: 'antennaStartTriggerType',
          title: 'INVENTORY START TRIGGER TYPE',
          type: 'zebraStartTriggerType',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'antennaStartTriggerValue',
          title: 'INVENTORY START TRIGGER VALUE',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'antennaStopTriggerType',
          title: 'INVENTORY STOP TRIGGER TYPE',
          type: 'zebraStopTriggerType',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'antennaStopTriggerValue',
          title: 'INVENTORY STOP TRIGGER VALUE',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'tagPopulationEstimate',
          title: 'TAG POPULATION ESTIMATE',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'tagTransitTime',
          title: 'TAG TRANSMIT TIME (SECONDS)',
          type: 'millisToSecond',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'autoStartPeriodMillis',
          title: 'AUTO START PERIOD SECOND(s)',
          type: 'millisToSecond',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'autoStopDurationMillis',
          title: 'AUTO STOP PERIOD SECOND(s)',
          type: 'millisToSecond',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'externalId',
          title: 'UUID',
          visible: false,
          sortable: false,
          disabled: false,
        },
        {
          key: 'readerType',
          title: 'READER TYPE',
          type: 'zebraReaderType',
          visible: true,
          sortable: true,
          disabled: false,
        },
        {
          key: 'createdBy',
          title: 'CREATED BY',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'createdTimestamp',
          title: 'CREATED TIME',
          type: 'datetime',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'lastModifiedBy',
          title: 'LAST MODIFIED BY',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'lastModifiedTimestamp',
          title: 'LAST MODIFIED TIME',
          type: 'datetime',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'status',
          title: 'STATUS',
          visible: false,
          sortable: true,
          disabled: false,
        },
        {
          key: 'actions',
          title: 'ACTIONS',
          visible: true,
          disabled: true,
          sortable: false,
        },
      ],
    },
    { keepAliveLabel: '', usedAsDefaultLabel: '', useTlsLabel: '' },
    {
      resetPageFilters() {
        const store = storeFn()
        store.resetBaseFilters()
      },
      copy(item) {
        const obj = {
          antennaStartTriggerType: item.antennaStartTriggerType,
          antennaStartTriggerValue: item.antennaStartTriggerValue,
          antennaStopTriggerType: item.antennaStopTriggerType,
          session: item.session,
          antennaStopTriggerValue: item.antennaStopTriggerValue,
          gpiPort: item.gpiPort,
          tagPopulationEstimate: item.tagPopulationEstimate,
          tagTransitTime: item.tagTransitTime,
          keepAlivesEnabled: item.keepAlivesEnabled,
          useTls: item.useTls,
          tari: item.tari,
          readerType: item.readerType,
          receiveSensitivityIndex: item.receiveSensitivityIndex,
          rfModeTableIndex: item.rfModeTableIndex,
          transmitFrequencyIndex: item.transmitFrequencyIndex,
        }
        return obj
      },
    },
    {
      actionBindings: {
        antennaStartTriggerType: 'antennaStartTriggerTypeUpdated',
        antennaStopTriggerType: 'antennaStopTriggerTypeUpdated',
      },
      fields: [
        {
          id: 'zebra_reader_reader_type',
          name: 'readerType',
          label: 'Reader Type',
          size: 4,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick reader type' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_session',
          name: 'session',
          label: 'Session',
          size: 4,
          component: 'NSelect',
          defaultValue: 1,
          componentProps: { placeholder: 'Pick RFID session' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_tag_population_estimate',
          name: 'tagPopulationEstimate',
          label: 'Tag Population Estimate',
          size: 4,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick expected tag population' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_gpi_port',
          name: 'gpiPort',
          label: 'GPI Port',
          size: 4,
          component: 'NSelect',
          defaultValue: 0,
          componentProps: { placeholder: 'Enter GPI port' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_antenna_start_trigger_type',
          name: 'antennaStartTriggerType',
          label: 'Inventory Start Trigger Type',
          size: 6,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick inventory start trigger type' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_antenna_start_trigger_value',
          name: 'antennaStartTriggerValue',
          label: 'Inventory Start Trigger Value',
          size: 6,
          component: 'Span',
          templateLabel: 'Not Applicable',
          visible: true,
          componentProps: { placeholder: '' },
          rules: [
            {
              required: false,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_antenna_stop_trigger_type',
          name: 'antennaStopTriggerType',
          label: 'Inventory Stop Trigger Type',
          size: 6,
          component: 'NSelect',
          componentProps: { placeholder: 'Pick inventory stop trigger type' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_antenna_stop_trigger_value',
          name: 'antennaStopTriggerValue',
          label: 'Inventory Stop Trigger Value',
          size: 6,
          component: 'Span',
          templateLabel: 'Not Applicable',
          visible: true,
          componentProps: { placeholder: '' },
          rules: [
            {
              required: false,
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_tag_transit_time',
          name: 'tagTransitTime',
          label: 'Tag Transit Time',
          size: 4,
          component: 'ArsTimeInput',
          defaultValue: 100,
          componentProps: { placeholder: 'Enter tag transit time' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_receive_sensitivity_index',
          name: 'receiveSensitivityIndex',
          label: 'Rx Sensitivity',
          size: 4,
          component: 'NSelect',
          defaultValue: 0,
          componentProps: { placeholder: 'Pick Rx sensitivity value' },
          rules: [
            {
              required: true,
              type: 'number',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_keep_alives_enabled',
          name: 'keepAlivesEnabled',
          size: 4,
          component: 'NCheckbox',
          label: 'Enable Keep Alives',
          templateLabel: 'keepAliveLabel',
          defaultValue: false,
          componentProps: {},
          rules: [
            {
              required: false,
              type: 'boolean',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_use_tls',
          name: 'useTls',
          size: 4,
          component: 'NCheckbox',
          label: 'Use TLS',
          templateLabel: 'useTlsLabel',
          componentProps: {},
          defaultValue: false,
          rules: [
            {
              required: false,
              type: 'boolean',
              trigger: ['blur', 'input'],
            },
          ],
        },
        {
          id: 'zebra_reader_name',
          name: 'name',
          label: 'Name',
          size: 24,
          component: 'NInput',
          componentProps: { placeholder: 'Enter descriptive reader name' },
          rules: [
            {
              required: true,
              trigger: ['blur', 'input'],
            },
          ],
        },
      ],
    }
  )
  const store = storeFn()

  const notRequiredAntennaStopTriggerValue = computed(() => {
    return (
      store.formData['antennaStopTriggerType'] === 'STOP_TRIGGER_TYPE_NONE' ||
      store.formData['antennaStopTriggerType'] === 'STOP_TRIGGER_TYPE_IMMEDIATE'
    )
  })
  const timeInputRequiredAntennaStopTriggerValue = computed(() => {
    return store.formData['antennaStopTriggerType'] === 'STOP_TRIGGER_TYPE_DURATION'
  })

  const timeInputRequiredAntennaStartTriggerValue = computed(() => {
    return store.formData['antennaStartTriggerType'] === 'START_TRIGGER_TYPE_PERIODIC'
  })

  const notRequiredAntennaStartTriggerValue = computed(() => {
    return (
      store.formData['antennaStartTriggerType'] === 'START_TRIGGER_TYPE_NONE' ||
      store.formData['antennaStartTriggerType'] === 'START_TRIGGER_TYPE_IMMEDIATE'
    )
  })

  watch(
    () => store.formData['antennaStartTriggerType'],
    () => {
      if (notRequiredAntennaStartTriggerValue.value) {
        store.form.fields
          .filter((d) => d.name === 'antennaStartTriggerValue')
          .forEach((d) => {
            d.visible = true
            d.component = 'Span'
            d.rules.forEach((r) => {
              r.type = 'string'
            })
          })
        store.formData['antennaStartTriggerValue'] = '0'
      }
      if (timeInputRequiredAntennaStartTriggerValue.value) {
        store.form.fields
          .filter((d) => d.name === 'antennaStartTriggerValue')
          .forEach((d) => {
            d.visible = true
            d.component = 'ArsTimeInput'
            d.componentProps.submitAs = 'millis'
            d.componentProps.showAs = 'seconds'
            d.rules.forEach((r) => {
              r.type = 'number'
            })
          })
      }
    },
    { immediate: true }
  )

  watch(
    () => store.formData['antennaStopTriggerType'],
    () => {
      if (notRequiredAntennaStopTriggerValue.value) {
        store.form.fields
          .filter((d) => d.name === 'antennaStopTriggerValue')
          .forEach((d) => {
            d.visible = true
            d.component = 'Span'
            d.rules.forEach((r) => {
              r.type = 'string'
            })
          })
        store.formData['antennaStopTriggerValue'] = '0'
      }
      if (timeInputRequiredAntennaStopTriggerValue.value) {
        store.form.fields
          .filter((d) => d.name === 'antennaStopTriggerValue')
          .forEach((d) => {
            d.visible = true
            d.component = 'ArsTimeInput'
            d.componentProps.submitAs = 'millis'
            d.componentProps.showAs = 'seconds'
            d.rules.forEach((r) => {
              r.type = 'number'
            })
          })
      }
    },
    { immediate: true }
  )
  const keepAlive = computed(() => store?.formData?.keepAlivesEnabled ?? true)
  watch(
    keepAlive,
    (checked) => {
      store.form.keepAliveLabel = checked ? 'Keep Alives Enabled' : 'Keep Alives Disabled'
    },
    { immediate: true }
  )

  const usedAs = computed(() => store?.formData?.usedAsDefault ?? true)
  watch(
    usedAs,
    (checked) => {
      store.form.usedAsDefaultLabel = checked ? 'Use as default' : 'Do not use default'
    },
    { immediate: true }
  )

  const tls = computed(() => store?.formData?.useTls ?? true)
  watch(
    tls,
    (checked) => {
      store.form.useTlsLabel = checked ? 'Use TLS' : 'Do not use TLS'
    },
    { immediate: true }
  )

  return store
}
